import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsRoutingModule } from './settings-routing.module';
import { SettingsContainerComponent } from './components/settings-container/settings-container.component';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [
    SettingsContainerComponent,
  ],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    SharedModule
  ]
})
export class SettingsModule { }
